module.exports = __webpack_public_path__ + "static/img/Risk240826EN.818590c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Risk240826EN.jpg
// module id = 4AdR
// module chunks = 1